import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from '@mui/material';
import { isEmpty } from 'lodash';
import { useCallback, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useCompanyCore } from '../../../core/modules/company';
import * as yup from 'yup';
import { useGlobalCore } from '../../../core/modules/global';
import { CREATE_GRAPH_DIALOG } from '../../../core/constants/dialog';
import { useMetricsCore } from '../../../core/modules/metrics';

interface FormData {
  barMetric: string;
  lineMetric: string;
}

const schema = yup.object().shape({
  barMetric: yup.string().required('You must enter a bar metric'),
  lineMetric: yup.string().required('You must enter a line metric'),
});

const defaultValues: FormData = {
  barMetric: '',
  lineMetric: '',
};

function GraphDialog() {
  const { dialog, closeDialog } = useGlobalCore();
  const { graphType, setGraphType, putGraphType, getGraphTypes } = useMetricsCore();
  const { company } = useCompanyCore();

  const { control, formState, handleSubmit, setValue, reset } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid, errors } = formState;

  const onSubmit = useCallback(
    ({
      barMetric,
      lineMetric,
    }: FormData) => {
      putGraphType(
        company?.id!,
        graphType?.id!,
        {
          barMetric,
          lineMetric,
        },
        () => {
          reset();
          setGraphType(null);
          closeDialog();
          getGraphTypes(company?.id!);
        }
      );
    },
    [putGraphType, company?.id, graphType?.id, reset, setGraphType, closeDialog, getGraphTypes]
  );

  useEffect(() => {
    if (graphType) {
      setValue('barMetric', graphType.barMetric);
      setValue('lineMetric', graphType.lineMetric);
    }
  }, [graphType, setValue]);

  return (
    <Dialog
      classes={{
        paper: 'm-8 sm:m-24 w-[400px]',
      }}
      onClose={closeDialog}
      open={dialog === CREATE_GRAPH_DIALOG}
    >
      <DialogContent>
        <div className="flex flex-auto flex-col py-16 px-0 sm:px-16">
          <div className="flex flex-col">
            <div className="mb-16 flex items-center">
              <Typography className="text-2xl font-bold truncate">
                Crear Gráfico
              </Typography>
            </div>

            <form
              name="projectForm"
              noValidate
              className="flex flex-col space-y-32"
              onSubmit={handleSubmit(onSubmit)}
            >
              <Controller
                control={control}
                name="barMetric"
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Gráfico de barra"
                    id="barMetric"
                    error={!!errors.barMetric}
                    helperText={errors?.barMetric?.message}
                    variant="outlined"
                    required
                    fullWidth
                  />
                )}
              />

              <Controller
                control={control}
                name="lineMetric"
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Gráfico de linea"
                    id="lineMetric"
                    error={!!errors.lineMetric}
                    helperText={errors?.lineMetric?.message}
                    variant="outlined"
                    required
                    fullWidth
                  />
                )}
              />

              <div className="flex justify-center">
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ borderRadius: 50 }}
                  disabled={!isEmpty(errors) || !isValid}
                  type="submit"
                >
                  Guardar
                </Button>
              </div>
            </form>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default GraphDialog;
